module.exports = __webpack_public_path__ + "static/media/40.68a41b3e.png";